import { Form } from "../Form/Form.js";
const form = new Form();
window.form = form;

// Resize
$(window).on("resize", function () {

});


// Scroll
$(window).on("scroll", function () {

})

function adjustMenuLayout() {
	const menu = document.querySelector('.header-menu-list');
	if (!menu) return;

	const items = Array.from(menu.children).filter(el => el.offsetParent !== null);
	if (items.length === 0) return;

	const firstRowTop = items[0].offsetTop;
	const isSingleRow = items.every(item => item.offsetTop === firstRowTop);

	menu.style.justifyContent = isSingleRow ? 'space-between' : 'auto';
}

window.addEventListener('load', adjustMenuLayout);
window.addEventListener('resize', adjustMenuLayout);

$(document).ready(function() {
	var pageTitle = $("#pageTitle").text();
	$("<li>").text(pageTitle).appendTo("#dynamicBreadcrumb");
});

$(function () {
	function fixRutubeShorts() {
		$('iframe[src*="rutube.ru/shorts/"]').each(function () {
			const $iframe = $(this);
			const src = $iframe.attr('src');
			if (!src.includes('/play/embed/')) {
				const fixedSrc = src.replace('rutube.ru/shorts/', 'rutube.ru/play/embed/');
				$iframe.attr('src', fixedSrc);
			}
		});
	}

	// Запускаем сразу после загрузки
	fixRutubeShorts();

	// И следим за динамически добавленными блоками
	const observer = new MutationObserver(() => fixRutubeShorts());
	observer.observe(document.body, { childList: true, subtree: true });
});

//HEADER//
$(document).ready(function() {
	// Показываем или скрываем все скрытые элементы при клике на кнопку
	$(".hidden-list-item").hide();
	$(".show-hidden-links").click(function() {
		$(".hidden-list-item").fadeToggle(); // Плавно переключаем видимость всех скрытых элементов
		$(this).find('.show-icon, .hide-icon').toggle(); // Переключаем иконки
	});
});
//HEADER//

let menuBtn = document.querySelector('.header-main__info-burger');
let menu = document.querySelector('.header-main__info-block');
// let headWrapper = document.querySelector('.header-wrapper');
let body = document.querySelector('body');
// let socialBtn = document.querySelector('.social-burger');

menuBtn.addEventListener('click', function(){
	menuBtn.classList.toggle('active');
	// headWrapper.classList.toggle('active');
	menu.classList.toggle('active');
	body.classList.toggle('no-scroll');
});

//accordion//
document.body.addEventListener("click", function(event) {
	let header = event.target.closest(".accordion-block-item-header");
	if (!header) return;

	let item = header.closest(".accordion-block-item");
	let content = item.querySelector(".accordion-block-item-content");
	let btn = item.querySelector(".accordion-block-item-toggle");

	if (content && btn) {
		content.classList.toggle("active");
		btn.classList.toggle("active");

		// Сохраняем ID, если аккордеон открылся
		if (content.classList.contains("active")) {
			localStorage.setItem("openAccordionId", item.id);
		} else {
			localStorage.removeItem("openAccordionId");
		}
	}
});

document.addEventListener("DOMContentLoaded", function() {
	let openId = localStorage.getItem("openAccordionId");
	if (openId) {
		let item = document.getElementById(openId);
		if (item) {
			let content = item.querySelector(".accordion-block-item-content");
			let btn = item.querySelector(".accordion-block-item-toggle");

			if (content && btn) {
				content.classList.add("active");
				btn.classList.add("active");
			}
		}
	}
});
//accordion//

//statistics//
// Функция для анимированного изменения чисел
function animateNumbers(element, finalNumber, duration) {
	let start = 0;
	let startTime = null;
	element.classList.remove('animated');

	function step(timestamp) {
		if (!startTime) startTime = timestamp;
		const progress = timestamp - startTime;
		const increment = finalNumber * (progress / duration);
		if (increment < finalNumber) {
			element.textContent = Math.ceil(increment).toLocaleString();
			requestAnimationFrame(step);
		} else {
			element.textContent = finalNumber.toLocaleString();
			element.classList.add('animated'); // Добавляем класс, чтобы запретить повторную анимацию
		}
	}

	requestAnimationFrame(step);
}

// Функция для проверки видимости элемента при прокрутке и запуска анимации
function checkVisibilityAndAnimate(elements) {
	elements.forEach(element => {
		const rect = element.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;

		if (rect.top >= 0 && rect.bottom <= windowHeight && !element.classList.contains('animated')) {
			const finalNumber = parseInt(element.getAttribute('data-final-number'), 10);
			animateNumbers(element, finalNumber, 3000); // 3000 - продолжительность анимации в миллисекундах
		}
	});
}

// Обработчик события scroll и resize
function handleScrollAndResize() {
	const h2Elements = document.querySelectorAll(".statistics-block-list li h2");
	const h3Elements = document.querySelectorAll(".statistics-preview-block-list li h3");
	
	checkVisibilityAndAnimate(h2Elements);
	checkVisibilityAndAnimate(h3Elements);
}

window.addEventListener('scroll', handleScrollAndResize);
window.addEventListener('resize', handleScrollAndResize);
window.addEventListener('load', handleScrollAndResize); // Для случаев, когда страница загружается сразу в середине блока

//statistics//

//form//
// Обработчик события отправки формы
$(document).ready(function() {
	$("#anketaForm").submit(function(event) {
		event.preventDefault(); // Предотвращаем стандартное действие формы (переход на другую страницу)
		
		// Здесь можно выполнить другие действия, связанные с отправкой формы,
		// например, отправить данные на сервер, отобразить сообщение об успешной отправке и т.д.
		
		// В данном примере мы просто отображаем сообщение об успешной отправке формы
		$("#anketaForm").hide();
		$("#success-message").show();
		
		// Здесь можно выполнить другие действия, связанные с отправкой формы
		// Например, можно отправить данные на сервер с использованием AJAX
	});
});

document.addEventListener('DOMContentLoaded', function () {
	// Функция для активации/деактивации текстового поля при выборе/сбросе чекбокса "Другое (указать)"
	function toggleOtherTextarea(checkbox, textarea) {
		textarea.disabled = !checkbox.checked;
		if (checkbox.checked) {
			textarea.focus();
		}
	}

	// Обработчики для всех вопросов с чекбоксом "Другое (указать)"

	// var otherCheckboxes = document.querySelectorAll('input[type="checkbox"][id^="other_"]');
	var otherCheckboxes = document.querySelectorAll('.answer-block[id$="other"] input[type="checkbox"]');
	// var otherTextareas = document.querySelectorAll('textarea[id^="other_"]');
	var otherTextareas = document.querySelectorAll('textarea[id$="_description"]');
	
	otherCheckboxes.forEach(function (checkbox, index) {
		checkbox.addEventListener('change', function () {
			toggleOtherTextarea(this, otherTextareas[index]);
		});
	});
});

document.addEventListener('DOMContentLoaded', function () {
	// Получаем все чекбоксы "нет"
	// var noCheckboxes = document.querySelectorAll('.answer-block input[type="checkbox"][value="нет"]');
	var noCheckboxes = document.querySelectorAll('.answer-block input[type="checkbox"][value="нет"]');
	
	// Добавляем обработчик события change для каждого чекбокса "нет"
	noCheckboxes.forEach(function (checkbox) {
		checkbox.addEventListener('change', function () {
			// Если чекбокс "нет" выбран
			if (this.checked) {
				// Получаем родительский элемент списка ответов
				var answerBlock = this.closest('.answer');
				// Получаем все чекбоксы в этом списке ответов, кроме текущего чекбокса "нет"
				// var otherCheckboxes = answerBlock.querySelectorAll('.answer-block input[type="checkbox"]:not([value="нет"])');
				var otherCheckboxes = answerBlock.querySelectorAll('.answer-block input[type="checkbox"]:not([value="' + this.value + '"])');
				
				// Сбрасываем выбранные значения других чекбоксов в текущем списке ответов
				otherCheckboxes.forEach(function (otherCheckbox) {
					otherCheckbox.checked = false;
				});
			}
		});
	});

	// Добавляем обработчик события change для каждого чекбокса, кроме "нет"
	// Обработчик для всех чекбоксов, кроме "нет"
	var allCheckboxesExceptNo = document.querySelectorAll('.answer-block input[type="checkbox"]:not([value="нет"])');
	allCheckboxesExceptNo.forEach(function (checkbox) {
		checkbox.addEventListener('change', function () {
			if (this.checked) {
				var answerBlock = this.closest('.answer');
				var noCheckbox = answerBlock.querySelector('.answer-block input[type="checkbox"][value="нет"]');

				if (noCheckbox && noCheckbox.checked) {
					noCheckbox.checked = false;
				}
			}
		});
	});
});

// document.getElementById('uploadButton').addEventListener('click', function() {
// 	var fileInput = document.createElement('input');
// 	fileInput.type = 'file';
// 	fileInput.multiple = true;
// 	fileInput.style.display = 'none';
// 	fileInput.addEventListener('change', function() {
// 		var fileList = document.getElementById('fileList');
// 		var files = this.files;
// 		for (var i = 0; i < files.length; i++) {
// 			var li = document.createElement('li');
// 			li.className = 'fileItem';
// 			li.innerHTML = `
// 			<span>${files[i].name}</span>
// 			<button class="deleteButton" type="button"><svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
// 			<path d="M1 1L13 13M13 1L1 13" stroke="Black" stroke-linecap="round"/>
// 			</svg>
// 			</button>
// 			`;
// 			fileList.appendChild(li);
// 		}
// 		// Отправка файлов на сервер
// 		var formData = new FormData();
// 		for (var i = 0; i < files.length; i++) {
// 			formData.append('files[]', files[i]);
// 		}
// 		// Пример отправки formData на сервер с использованием fetch
// 		fetch('/upload', {
// 			method: 'POST',
// 			body: formData
// 		})
// 		.then(response => response.json())
// 		.then(data => console.log(data))
// 		.catch(error => console.error('Ошибка:', error));
// 		// Удаление input после загрузки файлов
// 		this.remove();

// 		// Добавление обработчика для кнопок удаления файлов
// 		addDeleteButtonHandlers();
// 	});
// 	document.body.appendChild(fileInput);
// 	fileInput.click();
// });

function addDeleteButtonHandlers() {
	document.querySelectorAll('.deleteButton').forEach(button => {
		button.addEventListener('click', function() {
			this.closest('.fileItem').remove();
			// Здесь можно добавить логику удаления файла с сервера
		});
	});
}

  // Добавление обработчика для кнопок удаления файлов на странице загрузки
addDeleteButtonHandlers();

document.addEventListener('DOMContentLoaded', function () {
	const agreeCheckbox = document.getElementById('agreeCheckbox');
	const submitButton = document.getElementById('submitButton');

	if (!agreeCheckbox || !submitButton) {
		console.warn("Элементы не найдены: agreeCheckbox или submitButton");
		return; // Прерываем выполнение, чтобы не было ошибки
	}

	agreeCheckbox.addEventListener('change', function () {
		submitButton.disabled = !this.checked;
	});
});

//form//

//popups//
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});
//popups//

//MEDIA//
$(document).ready(function() {
	// Добавляем класс no-click к iframe при ширине окна 768 пикселей или менее
	if ($(window).width() <= 768) {
		$('.media-block-swiper .swiper-wrapper .swiper-slide iframe').addClass('no-click');
	}

	// Обработчик события касания на родителе iframe
	$('.media-block-swiper ul li').on('touchstart', function() {
		// Проверяем, есть ли у родителя iframe класс .no-click
		if ($(this).find('iframe').hasClass('no-click')) {
			// Удаляем класс no-click после первого касания на мобильном устройстве
			$(this).find('iframe').removeClass('no-click');
		}
	});
});

//MEDIA//

//MAPS//
$('.mapContainer').each(function() {
	var mapTitle = $('<div>').addClass('mapTitle');
	mapTitle.text('Для активации карты нажмите по ней');
	$(this).append(mapTitle);

	$(this).on('click', function() {
		$(this).children(':first').removeAttr('style');
		mapTitle.remove();
	});

	$(this).on('mousemove', function(event) {
		mapTitle.css('display', 'block');
		if (event.offsetY > 10) mapTitle.css('top', event.offsetY + 20 + 'px');
		if (event.offsetX > 10) mapTitle.css('left', event.offsetX + 20 + 'px');
	});

	$(this).on('mouseleave', function() {
		mapTitle.css('display', 'none');
	});
});
//MAPS//

//IFRAME//
$(document).ready(function () {
  function processIframe(iframe) {
    $(iframe).on('load', function () {
      try {
        const innerDoc = this.contentDocument || this.contentWindow.document;
        const videos = innerDoc.querySelectorAll('video');

        videos.forEach(video => {
          // Отключаем автоплей
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.pause();

          // Убираем жесткие размеры
          video.style.setProperty('min-width', '0', 'important');
          video.style.setProperty('min-height', '0', 'important');
          video.style.setProperty('width', '100%', 'important');
          video.style.setProperty('height', 'auto', 'important');
          video.style.setProperty('max-width', '100%', 'important');

          // Принудительно обновляем layout
          video.style.display = 'none';
          // Триггер перерисовки
          void video.offsetHeight;
          video.style.display = '';
        });
      } catch (e) {
        console.warn('Не удалось обработать iframe:', e);
      }
    });
  }

  // Обрабатываем все текущие iframe
  $('iframe').each(function () {
    processIframe(this);
  });

  // Следим за новыми iframe
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      $(mutation.addedNodes).each(function () {
        if (this.tagName === 'IFRAME') {
          processIframe(this);
        } else {
          $(this).find('iframe').each(function () {
            processIframe(this);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});